import React from 'react';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import { errorMessageContainer } from './ErrorMessage.module.css';

const ShowBlockError = ({ message = '', image, ContainerStyle = {} }) => {
  return (
    <div
      className={`w-auto mr-auto ml-3 bg-red-600 rounded flex items-center px-2 py-2 ${errorMessageContainer}`}
      style={ContainerStyle}
    >
      <div className="w-10 text-center ">
        {image ? image : <NotInterestedIcon style={{ color: '#FD4F60' }} />}
      </div>
      <div className="w-full px-1 text-red-500 font-medium text-sm">
        {message}
      </div>
    </div>
  );
};

export default ShowBlockError;
